import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  TextField,
  Select,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  CircularProgress,
  Link,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { CardElement, useRecurly } from '@recurly/react-recurly';
import { signUp, getRecurlyPlanOpen } from '../services/Backend/account';
import countries from '../services/utils/countries.js';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import AdvisoryCloudLogo from '../components/AdvisoryCloudLogo';
import TrustPilotBanner from '../components/TrustPilotBanner';

const bullets = [
  'Guaranteed board placement given our exclusive relationships.',
  'Board matching and setup call to optimize your Advisor Profile and Advisor Rate.',
  'Leverage your Advisor Profile to connect with new professional opportunities.',
  'Cancel your free trial within 14 days and pay nothing, then only $195/ month.',
];

const CheckoutPage = () => {
  const location = useLocation();
  const recurly = useRecurly();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [planData, setPlanData] = useState(null);
  const [form, setForm] = useState({
    givenName: '',
    surName: '',
    email: '',
    phoneNumber: '5555555555',
    country: 'US',
    // address: '',
    // city: '',
    // state: '',
    postalCode: '',
    // companyName: '',
    acceptTerms: true,
  });
  const [cardValid, setCardValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const recurlyPlanCode = 'jb-m-coo-ft-pro-limited';

  // Extraer params de URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const mapping = {
      first_name: 'givenName',
      last_name: 'surName',
      email: 'email',
      phone: 'phoneNumber',
      company_name: 'companyName',
    };
    const newForm = { ...form };
    Object.entries(mapping).forEach(([key, field]) => {
      if (params.has(key)) newForm[field] = params.get(key);
    });
    setForm(newForm);
  }, []);

  // Cargar datos del plan
  useEffect(() => {
    getRecurlyPlanOpen(recurlyPlanCode).then((res) => setPlanData(res));
  }, []);

  const handleChange = (field) => (e) =>
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Ejecutar Recaptcha V3
      const recaptchaToken = await executeRecaptcha('signUp');

      // Token de Recurly
      const recurlyForm = {
        first_name: form.givenName,
        last_name: form.surName,
        address1: form.address,
        city: form.city,
        state: form.state,
        postal_code: form.postalCode,
        country: form.country,
      };

      recurly.token(recurlyForm, async (err, token) => {
        if (err) throw err;
        const res = await signUp({
          ...form,
          companyName: form.companyName || form.givenName + ' ' + form.surName,
          phoneCountryCode: form.country,
          recurlyBillingToken: token.id,
          recurlyPlanCode,
          urlOfCheckoutPage: window.location.href,
          acceptTermsOfService: form.acceptTerms,
          recaptchaToken,
        });
        try {
          if (res.errors && res.errors.length > 0) {
            console.error('Sign up errors:', res.errors);
            console.error(JSON.parse(res.errors[0].message));
            setError(
              JSON.parse(res.errors[0].message).error.message ||
                'Something went wrong'
            );
            throw res.errors[0];
          }
          console.log('Sign up response:', res);
          const { checkoutRedirectUrl, accountType } = res;
          console.log('Checkout redirect URL:', checkoutRedirectUrl);
          console.log('Account type:', accountType);
          if (checkoutRedirectUrl) {
            window.location.assign(
              checkoutRedirectUrl + window.location.search
            );
          } else {
            window.location.assign(
              `/${
                accountType === 'B2B' ? 'company' : 'advisor'
              }/confirmation?email=${form.email}`
            );
          }
        } catch (error) {
          console.error(error);
          // setError(error.message || 'Something went wrong');
          setLoading(false);
          return;
        }
      });
    } catch (err) {
      console.error('Error during sign up:', err);
      // Manejo de errores
      setError(err.message || 'Something went wrong');
      setLoading(false);
    }
  };

  const isValid = () => {
    if (!planData) return false;
    const basic = form.givenName && form.surName && form.email;
    if (planData.isFreemium) return basic;
    return (
      basic &&
      // form.address &&
      // form.city &&
      // form.state &&
      form.postalCode &&
      form.acceptTerms &&
      cardValid
    );
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mt: 1,
          mb: -3,
        }}
      >
        <AdvisoryCloudLogo
          removeHyperlink
          // onClick={() => history.push('/dashboard')}
          width={255}
        />
      </Box>
      <Typography
        sx={{ mt: 2, fontSize: '48px', fontWeight: 800, textAlign: 'center' }}
      >
        You've matched with{' '}
        <span style={{ color: 'rgb(20, 120, 248)' }}>74</span> boards!
      </Typography>
      <Typography
        sx={{
          mt: 1,
          mb: 3,
          fontSize: '20px',
          textAlign: 'center',
          color: 'rgb(49, 60, 79)',
          fontWeight: 400,
          fontSize: '28px',
        }}
      >
        Start your complimentary {Math.ceil(planData?.lengthOfTrialInDays / 7)}
        -week trial.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 750,
          mx: 'auto',
          mb: 4,
        }}
      >
        {bullets.map((text, index) => (
          <Typography
            key={index}
            sx={{
              color: 'rgb(49, 60, 79)',
              fontSize: '18px',
              // fontStyle: 'normal',
              fontWeight: 400,
              // lineHeight: '24px',
              // letterSpacing: '-0.43px',
              marginBottom: '10px',
            }}
          >
            <span
              style={{
                color: '#0F78FD',
                fontWeight: 700,
                marginRight: '5px',
              }}
            >
              ✓
            </span>{' '}
            {text}
          </Typography>
        ))}
      </Box>
      <TrustPilotBanner />
      <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4, mb: 2 }}>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="First Name"
                value={form.givenName}
                onChange={handleChange('givenName')}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Last Name"
                value={form.surName}
                onChange={handleChange('surName')}
              />
            </Grid>
            {/* <Grid item xs={12}>
            <TextField
              fullWidth
              label="Business, Team, or Project Name"
              value={form.companyName}
              onChange={handleChange('companyName')}
            />
          </Grid> */}
            <Grid item xs={12} sx={{ mb: '-8px' }}>
              <TextField
                fullWidth
                label="Email"
                value={form.email}
                onChange={handleChange('email')}
              />
            </Grid>
            {/* <Grid item xs={12}>
            <TextField
              fullWidth
              label="Phone"
              value={form.phoneNumber}
              onChange={handleChange('phoneNumber')}
            />
          </Grid> */}
            {/* <Grid item xs={12} sm={6} md={4}>
            <Select
              fullWidth
              value={form.country}
              onChange={handleChange('country')}
            >
              {countries.map((c) => (
                <MenuItem key={c.value} value={c.value}>
                  {c.text}
                </MenuItem>
              ))}
            </Select>
          </Grid> */}

            {planData?.accountType === 'B2C' && !planData.isFreemium && (
              <>
                {/* <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Address"
                  value={form.address}
                  onChange={handleChange('address')}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="City"
                  value={form.city}
                  onChange={handleChange('city')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="State"
                  value={form.state}
                  onChange={handleChange('state')}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  fullWidth
                  label="Zip Code"
                  value={form.postalCode}
                  onChange={handleChange('postalCode')}
                />
              </Grid> */}
                <Grid item xs={12}>
                  <CardElement
                    options={{
                      style: {
                        base: {
                          fontSize: '16px',
                          color: '#32325d',
                          '::placeholder': { color: '#aab7c4' },
                        },
                        invalid: { color: '#fa755a' },
                      },
                    }}
                    onChange={(e) => setCardValid(e.valid)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Zip Code"
                    value={form.postalCode}
                    onChange={handleChange('postalCode')}
                  />
                </Grid>
              </>
            )}

            {/* <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.acceptTerms}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      acceptTerms: e.target.checked,
                    }))
                  }
                />
              }
              label={
                planData?.isFreemium
                  ? 'Start for Free'
                  : 'I agree to Terms & Privacy'
              }
            />
          </Grid> */}

            {error && (
              <Grid item xs={12}>
                <Typography color="error">{error}</Typography>
              </Grid>
            )}

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={!isValid() || loading}
              >
                {loading ? (
                  <CircularProgress size={24} />
                ) : planData?.isFreemium ? (
                  'Start Your Free Trial'
                ) : (
                  'Create Account'
                )}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxWidth: 440,
          mx: 'auto',
          mb: 4,
        }}
      >
        <Typography
          sx={{
            color: '#313C4F',
            fontSize: '14px',
            marginBottom: '10px',
          }}
        >
          ✓ We will NOT bill your credit card for 14 days. Guaranteed.
        </Typography>
        <Typography
          sx={{
            color: '#313C4F',
            fontSize: '14px',
            marginBottom: '10px',
          }}
        >
          ✓ After 14 days your membership renews monthly at $195.
        </Typography>
        <Typography
          sx={{
            color: '#313C4F',
            fontSize: '14px',
            marginBottom: '10px',
          }}
        >
          ✓ By starting your free trial, you agree to our{' '}
          <Link
            href="https://www.advisorycloud.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </Link>
          .
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ fontSize: '10px', mt: 5 }}>
        This site is protected by reCAPTCHA and the Google{' '}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{' '}
        and{' '}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>{' '}
        apply.
      </Typography>
      <Box
        component="section"
        sx={{
          bgcolor: '#2a3243',
          color: 'white',
          p: 2,
          textAlign: 'center',
          flexDirection: 'row',
          display: 'flex',
          bottom: 0,
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            margin: '25px auto',
            minWidth: '650px',
            justifyContent: 'space-between',
          }}
        >
          <Typography>
            Copyright 2025 AdvisoryCloud, Inc All Rights Reserved.{' '}
          </Typography>
          <Link
            href="https://www.advisorycloud.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'white'}}
          >
            Privacy Policy
          </Link>
          <Link
            href="https://www.advisorycloud.com/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: 'white' }}
          >
            Terms of Use
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default CheckoutPage;
